<script setup>
import VueApexCharts from "vue3-apexcharts";
import useRASChart from "../hooks/useRASChart.js";
import useRASByDistrictChart from "../hooks/useRASByDistrictChart.js";

const {
  loadReport: loadRASType1,
  data: chartDataType1,
  total,
} = useRASChart(1);
const { loadReport: loadRASType2, data: chartDataType2 } = useRASChart(2);
const { loadReport: loadRASType3, data: chartDataType3 } =
  useRASByDistrictChart(3);
loadRASType1();
loadRASType2();
loadRASType3();
</script>

<template>
  <div class="ras-charts">
    <h2 class="ras-charts__header">Лица с РАС</h2>
    <div class="ras-charts__total">Итого: {{ total }} чел.</div>
    <div class="ras-charts__persons">
      <VueApexCharts v-bind="chartDataType1" height="250px" width="400px" />
      <VueApexCharts v-bind="chartDataType2" height="250px" width="400px" />
    </div>
    <div class="ras-charts__districts mb-4">
      <VueApexCharts v-bind="chartDataType3" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.ras-charts__districts {
  height: 540px;
  overflow-y: scroll;
}
</style>
